import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
//import { AUTH_CHECK, AUTH_LOGOUT } from './store/actions/auth'

import spinner from "@/components/spinner"
Vue.component('spinner', spinner)

//good-table
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);

/*MOMENT JS*/
import VueMoment from 'vue-moment';
Vue.use(VueMoment);

/* Cookies */
import Cookies from 'js-cookie'
Vue.use(Cookies);

/* FONTAWESOME */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add( fas, fab, far )

Vue.component('font-awesome-icon', FontAwesomeIcon)

/* Import the firebase SDK and extend with firestore */
//import * as firebase from "firebase/app";
//import firebase from 'firebase/app';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

//TEST FIREBASE ACCOUNT
/*
const firebaseConfig = {
    apiKey: "AIzaSyBMbBEFThaSfDCjYnGMGiVvv89Evr8e6qk",
    authDomain: "test-45417.firebaseapp.com",
    databaseURL: "https://test-45417.firebaseio.com",
    projectId: "test-45417",
    storageBucket: "test-45417.appspot.com",
    messagingSenderId: "314982766682",
    appId: "1:314982766682:web:1c9cbed24270f5e3232063",
    measurementId: "G-9T79YH950P"
  }

*/

var firebaseConfig = {
    apiKey: "AIzaSyAY7C79RoGKqDaQswQkOCJ8w9fOMb1gvKg",
    authDomain: "atlass-37ffa.firebaseapp.com",
    databaseURL: "https://atlass-37ffa.firebaseio.com",
    projectId: "atlass-37ffa",
    storageBucket: "atlass-37ffa.appspot.com",
    messagingSenderId: "801248366315",
    appId: "1:801248366315:web:cc0b24a639e7db416d78ae",
    measurementId: "G-MRJPRJM917"
};

/*
var firebaseConfig = {
    apiKey: "AIzaSyB4nWYNPXoYpvd9B7gbqmNnAnhiC7idkfg",
    authDomain: "atlass-app-9b166.firebaseapp.com",
    projectId: "atlass-app-9b166",
    storageBucket: "atlass-app-9b166.appspot.com",
    messagingSenderId: "516559886776",
    appId: "1:516559886776:web:be84c110948f899b3dd74d",
    measurementId: "G-K0D9XLTD0N"
};
*/

firebase.initializeApp(firebaseConfig);
/* Bind firebase to your Vue instance */
Vue.prototype.$firebase = firebase;

//use components
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
Vue.use(BootstrapVue)

Vue.config.productionTip = false

/* Multiselect */
import Multiselect from 'vue-multiselect'
Vue.component('Multiselect', Multiselect)
//<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
import "vue-multiselect/dist/vue-multiselect.min.css"

/* TOASTER */
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'

var toastrConfigs = {
    position: 'bottom right',
    timeOut: 3500,
    showDuration: 800
}
Vue.use(CxltToastr, toastrConfigs)

/*CHART JS*/
import VueCharts from 'vue-chartjs'
import { Bar, Line, Pie, Radar } from 'vue-chartjs'

import lineChart from './components/charts/lineChart'
Vue.component('line-chart', lineChart)
/*
import barChart from './components/charts/barChart'
Vue.component('bar-chart', barChart)
import pieChart from './components/charts/pieChart'
Vue.component('pie-chart', pieChart)
import radarChart from './components/charts/radarChart'
Vue.component('radar-chart', radarChart)
*/

//DATEPICKER
import DatePicker from 'vue2-datepicker'
Vue.component('date-picker', DatePicker)

//sweetalert
import VueSweetalert2 from 'vue-sweetalert2'
Vue.use(VueSweetalert2);

//IMPORT GLOBAL.SCSS
import './assets/css/global.scss'

import VueGapi from 'vue-gapi'

Vue.use(VueGapi, {
    apiKey: 'AIzaSyCXnh5uWKjwcTq0vPeo-Q3KicZNCb9yL-4',
    clientId: '1022726355435-777qvs0mukg5bb56b6p52u14h39smgvk.apps.googleusercontent.com',
    discoveryDocs: ['https://people.googleapis.com/$discovery/rest'],
    //scope: 'https://www.googleapis.com/auth/userinfo.profile',
    scope: "profile ",
    //access_type: 'offline',
    //prompt: "consent",
    refreshToken: true
})

/* eslint-disable no-new */

/*
//FIREBASE
let app;
firebase.auth().onAuthStateChanged(user => {
    if( !app ){
        app = new Vue({
            el: '#app',
            router,
            /\*
            watch:{
                '$route' (to, from){
                    // Code
                    let userToken =  Cookies.get('user-token')
                    let user =  Cookies.get('user')
                    user = JSON.parse( atob( user ) )

                    //if( process.env.NODE_ENV == "development"  ){ console.log(user) }

                    let document = { operationType: 'NAVIGATION', operationResult: "SUCCESS", operationMessage: "", email: user.email, token: userToken, agent: navigator.userAgent }
                    document.datetime = Math.round(+new Date()/1000)
                    document.from = from
                    document.to = to
                    //console.log(document)
                    if( user.role != 0 ){
                        firebase.firestore().collection('users/'+user.userID+'/logs').add( document )
                    }

                }
            },
            *\/
            store,
            render: h => h(App),
        }).$mount('#app')
    }
    //console.log(user)
    store.dispatch("AUTH_CHECK");
});
//FIREBASE
*/

new Vue({
    //i18n,
    render: h => h(App),
    store,
    router,
    components: { App },
    mounted(){

        //console.log("page refresh")

        axios.interceptors.response.use((response) => {
            //console.log('RESPONSE', response)
            if (response.status === 401) {
                //console.log('You are not authorized')
                return Promise.reject(response)
            } else if (response.status === 200) {
                //console.log('response SUCC'
                if( response.data.status == 403 ){
                    store.dispatch('AUTH_LOGOUT')
                    //router.push('/login')
                }
                return response
            }
        }, (error) => {

            console.log(error)
            if (error.response.data.error.statusCode === 403) {
                store.dispatch('AUTH_LOGOUT')
                //router.push('/login')
            }
            return Promise.reject(error)
        })


    },
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js